import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles({
    root: {
        verticalAlign: "middle",
        height: 20,
        marginRight: "8px"
    }
})